<!-- eslint-disable vue/no-v-html -->
<template>
  <div>
    <div v-if="!hideCookieAlert" class="fixed bottom-0 left-0 w-screen">
      <div class="mb-2 mx-2 cookie-alert rounded">
        <div class="p-4">
          <div class="text-white">
            <p class="inline">
              {{ $t("pages.cookie_alert.text1") }}
            </p>
            <p
              class="cursor-pointer inline underline"
              @click="privacyNoticeShow = true"
            >
              {{ $t("pages.cookie_alert.text2") }}
            </p>
            <p class="inline">
              {{ $t("pages.cookie_alert.text3") }}
            </p>
            <p class="cursor-pointer underline mt-2" @click="settings">
              {{ $t("pages.cookie_alert.settings") }}
            </p>
          </div>
          <div class="flex justify-end content-center">
            <button
              class="bg-white p-2 rounded font-semibold text-black hover:bg-red-600 hover:text-white"
              @click="accept"
            >
              {{ $t("pages.cookie_alert.submit") }}
            </button>
          </div>
        </div>
      </div>

      <ModalBase
        v-show="privacyNoticeShow"
        modal-type="initial"
        @close="privacyNoticeShow = !privacyNoticeShow"
      >
        <template #header>
          {{ $t("pages.cookie_alert.privacy_note.header") }}
        </template>
        <template #body>
          <div
            class="mt-4 overflow-x-auto border p-2 shadow-inner text-sm"
            style="height: 300px;"
          >
            <div>
              <div class="font-bold">
                {{ $t("pages.cookie_alert.privacy_note.parts[0].header") }}
              </div>
              <div>
                <p>
                  {{ $t("pages.cookie_alert.privacy_note.parts[0].text1") }}
                </p>
                <p class="mt-4">
                  {{ $t("pages.cookie_alert.privacy_note.parts[0].text2") }}
                </p>
              </div>
            </div>
            <div class="mt-4">
              <div class="font-bold">
                {{ $t("pages.cookie_alert.privacy_note.parts[1].header") }}
              </div>
              <div>
                <p>
                  {{ $t("pages.cookie_alert.privacy_note.parts[1].text1") }}
                </p>
                <p class="mt-4">
                  {{ $t("pages.cookie_alert.privacy_note.parts[1].text2") }}
                </p>
                <p class="mt-4">
                  {{ $t("pages.cookie_alert.privacy_note.parts[1].text3") }}
                </p>
                <p class="mt-4">
                  {{ $t("pages.cookie_alert.privacy_note.parts[1].text4") }}
                </p>
              </div>
            </div>

            <div class="mt-4">
              <div class="font-bold">
                {{ $t("pages.cookie_alert.privacy_note.parts[2].header") }}
              </div>
              <div>
                <p>
                  {{ $t("pages.cookie_alert.privacy_note.parts[2].text1") }}
                </p>
                <p class="mt-4">
                  {{ $t("pages.cookie_alert.privacy_note.parts[2].text2") }}
                </p>
                <p class="mt-4">
                  {{ $t("pages.cookie_alert.privacy_note.parts[2].text3") }}
                </p>
                <p
                  v-html="$t('pages.cookie_alert.privacy_note.parts[2].text4')"
                ></p>
              </div>
            </div>

            <div class="mt-4">
              <div class="font-bold">
                {{ $t("pages.cookie_alert.privacy_note.parts[3].header") }}
              </div>
              <div>
                <p>
                  {{ $t("pages.cookie_alert.privacy_note.parts[3].text1") }}
                </p>
                <p class="mt-4">
                  {{ $t("pages.cookie_alert.privacy_note.parts[3].text2") }}
                </p>
                <p class="mt-4">
                  {{ $t("pages.cookie_alert.privacy_note.parts[3].text3") }}
                </p>
                <p
                  class="mt-4"
                  v-html="$t('pages.cookie_alert.privacy_note.parts[3].text4')"
                ></p>
                <p class="mt-4">
                  {{ $t("pages.cookie_alert.privacy_note.parts[3].text5") }}
                </p>
                <p
                  class="mt-4"
                  v-html="$t('pages.cookie_alert.privacy_note.parts[3].text6')"
                ></p>
              </div>
            </div>
          </div>
        </template>
        <template #footer>
          <div class="flex">
            <button
              class="border rounded py-2 px-4 mt-4 cursor-pointer shadow w-24"
              @click="privacyNoticeShow = false"
            >
              {{ $t("pages.cookie_alert.privacy_note.buttons.close") }}
            </button>
          </div>
        </template>
      </ModalBase>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import ModalBase from "./shared/ModalBase";

export default {
  name: "CookieAlert",
  components: {
    ModalBase
  },
  data() {
    return {
      privacyNoticeShow: false
    };
  },
  computed: {
    ...mapGetters("app", {
      hideCookieAlert: "hideCookieAlert"
    })
  },
  methods: {
    accept() {
      this.$store.dispatch("app/hideCookieAlert");
    },

    settings() {
      this.$store.commit("app/showGdprModal");
    }
  }
};
</script>

<style scoped>
.cookie-alert {
  background-color: #2a2a2a;
  opacity: 1;
}
</style>
